export default "__VITE_ASSET__cc25e56a__"